/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteSurveyResponseAsync$Json$Params {

/**
 * surveyresponse id
 */
  surveyResponseId: number;
}

export function deleteSurveyResponseAsync$Json(http: HttpClient, rootUrl: string, params: DeleteSurveyResponseAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, deleteSurveyResponseAsync$Json.PATH, 'delete');
  if (params) {
    rb.path('surveyResponseId', params.surveyResponseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

deleteSurveyResponseAsync$Json.PATH = '/api/SurveyResponse/{surveyResponseId}';
